import { Component, inject } from '@angular/core';
import { BookDemoButtonComponent } from '@components/book-demo-button/book-demo-button.component';
import { HelperService } from '@services/helper.service';

@Component({
  selector: 'app-header',
  imports: [BookDemoButtonComponent],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  private helperService = inject(HelperService);

  scrollToSection(sectionId: string): void {
    this.helperService.scrollToSection(sectionId);
  }
}
